<article class="content-container">
  <h2>Site Footfall Insights</h2>
</article>
